'use client';

import { __assign } from '../../_virtual/_tslib.js';
import formErrorsControl from './formErrorsControl.js';
import getFieldValidatedMessage from './getFieldValidatedMessage.js';

function setFormFieldValue(_a) {
    var formState = _a.formState, field = _a.field, value = _a.value, rules = _a.rules;
    formState.values[field] = value;
    /*
     * Add value to watch field
     * */
    var watchFields = formState.watch;
    if (Object.keys(watchFields).length > 0) {
        Object.keys(watchFields).forEach(function (key) {
            var _a;
            if (watchFields[key].includes(field)) {
                formState.watchValues[key] = __assign(__assign({}, formState.watchValues[key]), (_a = {}, _a[field] = value, _a));
            }
        });
    }
    var isFieldTouched = formState.touched.includes(field);
    var isEnableValidate = formState.isSubmited || isFieldTouched;
    /*
     * Validate field onChange
     * */
    if (rules !== undefined) {
        var watchValueFields = formState.watchValues[field];
        var errorMsg = getFieldValidatedMessage({
            fieldValue: value,
            fieldRules: rules,
            fieldWatch: watchValueFields,
            isEnable: isEnableValidate
        });
        formErrorsControl({
            fieldName: field,
            formValues: formState,
            errorMsg: errorMsg,
            requestScrollToFirstErrorElement: false
        });
    }
}

export { setFormFieldValue as default };
//# sourceMappingURL=setFormFieldValue.js.map
